import { baseApi } from './baseApi';

export const companyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCompany: builder.query({
      query: () => '/companies/current',
      providesTags: ['Company'],
    }),
    updateCurrentCompany: builder.mutation({
      query: (data) => ({
        url: '/companies/current',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Company'],
    }),
    updateCompanyLogo: builder.mutation({
      query: (formData) => ({
        url: '/companies/current/logo',
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['Company'],
    }),
    testPrinterConnection: builder.mutation({
      query: (data) => ({
        url: '/companies/test-printer',
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const {
  useGetCurrentCompanyQuery,
  useUpdateCurrentCompanyMutation,
  useUpdateCompanyLogoMutation,
  useTestPrinterConnectionMutation,
} = companyApi;
